// extracted by mini-css-extract-plugin
module.exports = {"colors":"'styles/colors.module.css'","PURPLE":"#830051","container":"styles_container__BgC1f","response":"styles_response__eOdJe","text":"styles_text__MoMHc"};